import numberToPercentage from './numberToPercentage';
import numberToTime from './numberToTime';
import datetime from './datetime';
import duration from './duration';
import date from './date';
import time from './time';
import newClassGradeText from './newClassGradeText';

export const filters = {
  numberToPercentage,
  numberToTime,
  datetime,
  duration,
  date,
  time,
  newClassGradeText,
};

export default function install(Vue) {
  Object.keys(filters).forEach((name) => {
    Vue.filter(name, filters[name]);
  });
}



// WEBPACK FOOTER //
// ./src/filters/index.js